import React from 'react'

function FixtureStatistics({fixture}) {
    return (
        <div className="row text-center bg-white py-2">
                        <div className="col-4 col-md-2 text-center">
                            <img src={fixture.homeTeam.logo} className="img-fluid" style={{maxWidth: "50px"}} />
                        </div>
                        <div className="text-center col-4 col-md-8">
                            <br/>
                            Lagstatistikk
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <img src={fixture.awayTeam.logo} className="img-fluid" style={{maxWidth: "50px"}} />
                        </div>

                        <div className="col-12"><hr/></div>

                        <div className="col-md-2">
                            <label>Ball possession</label>
                            <p>{fixture.statistics && fixture.statistics["Ball Possession"].home} - {fixture.statistics["Ball Possession"].away}</p>
                        </div>
                        <div className="col-md-2">
                            <label>Fouls</label>
                            <p>{fixture.statistics && fixture.statistics["Fouls"].home} - {fixture.statistics["Fouls"].away}</p>
                        </div>
                        <div className="col-md-2">
                            <label>Corners</label>
                            <p>{fixture.statistics && fixture.statistics["Corner Kicks"].home} - {fixture.statistics["Corner Kicks"].away}</p>
                        </div>
                        <div className="col-md-2">
                            <label>Yellow cards</label>
                            <p>{fixture.statistics && fixture.statistics["Yellow Cards"].home} - {fixture.statistics["Yellow Cards"].away}</p>
                        </div>
                        <div className="col-md-2">
                            <label>Passes accurate</label>
                            <p>{fixture.statistics && fixture.statistics["Passes accurate"].home} - {fixture.statistics["Passes accurate"].away}</p>
                        </div>
                        <div className="col-md-2">
                            <label>Shots on goal</label>
                            <p>{fixture.statistics && fixture.statistics["Shots on Goal"].home} - {fixture.statistics["Shots on Goal"].away}</p>
                        </div>
                        {console.log(fixture.statistics && fixture.statistics)}
                        
                    </div>
    )
}
export default FixtureStatistics